export interface ApiEndpointConfig {
  baseUrl: string;
  getToken: () => string;
}

export interface ApiRuntimeConfig {
  default: ApiEndpointConfig;
  /** Optional secondary service. Falls back to `default` when omitted. */
  ai?: ApiEndpointConfig;
}

let runtime: ApiRuntimeConfig | null = null;

/**
 * Supplies the per-app environment the API layer needs.
 *
 * Must run before the first request is issued — see each app's
 * `src/apiRuntime.ts`. Keeping `import.meta.env` in the apps is what lets this
 * lib stay bundler-agnostic and testable without stubbing `import.meta`.
 */
export function configureApiRuntime(config: ApiRuntimeConfig): void {
  runtime = config;
}

/** Test-only escape hatch. */
export function resetApiRuntime(): void {
  runtime = null;
}

export function getApiRuntime(
  key: 'default' | 'ai' = 'default'
): ApiEndpointConfig {
  if (!runtime) {
    throw new Error(
      '@consolidocs-ui/data-access: configureApiRuntime() must be called before ' +
        'any request is issued. Import "./apiRuntime" first in your main.tsx.'
    );
  }
  return (key === 'ai' ? runtime.ai : undefined) ?? runtime.default;
}
